import { Injectable, Inject } from '@angular/core';
import { StorageService } from './storage.service';
import { HttpHeaders, HttpClient, HttpHeaderResponse } from '@angular/common/http';
import { site } from '../../global';

@Injectable()
export class ConsumptionService {

    constructor(private storageService: StorageService,
        private http: HttpClient,
        @Inject('API_BASE_URL') private baseUrl: string) {

    }

    private firstQueryString: boolean = false;

    getAverageMeterMonthlyConsumption(clientId: number, supplyCategory: string, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'Consumption/averagemetermonthlyconsumption/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get monthly consumption data"
                    });
                });
        });

        return promise;
    }

    getMetersSummary(clientId: number, supplyCategory: string, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'Consumption/meters/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get meter summary data"
                    });
                });
        });

        return promise;
    }


    getAverageMeterDailyConsumption(clientId: number, supplyCategory: string, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Consumption/averagemeterdailyconsumption/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get daily consumption data"
                    });
                });
        });

        return promise;
    }


    getMonthlyReadDataAvailability(clientId: number, supplyCategory: string, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Consumption/monthlyreaddataavailability/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get monthly read data avaliable data"
                    });
                });
        });

        return promise;
    }

    getDailyReadDataAvailability(clientId: number, supplyCategory: string, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Consumption/dailyreaddataavailability/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get daily read data avaliable data"
                    });
                });
        });

        return promise;
    }

    getMonthlyTotalConsumption(clientId: number, supplyCategory: string, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Consumption/monthlytotalconsumption/' + clientId;

        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get monthly total consumption data"
                    });
                });
        });

        return promise;
    }

    getDailyTotalConsumption(clientId: number, supplyCategory: string, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Consumption/dailytotalconsumption/' + clientId;
       
        this.firstQueryString = true;
        if (siteId && siteId != 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (supplyCategory) url = url.concat(this.createQueryStringParameter('supplyCategory', supplyCategory));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get daily total consumption data"
                    });
                });
        });

        return promise;
    }

    getDocumentData(siteId: string, StartDate: string, EndDate: string, Supply: string, Bulk: string): Promise<any> {
        let url = this.baseUrl + 'DocumentDownload';
        url = url.replace("api", "Document");
        this.firstQueryString = true;
        if (siteId && siteId !== "") url = url.concat(this.createQueryStringParameter('siteID', siteId));
        if (StartDate) url = url.concat(this.createQueryStringParameter('StartDate', StartDate));
        if (EndDate) url = url.concat(this.createQueryStringParameter('EndDate', EndDate));
        if (Supply) url = url.concat(this.createQueryStringParameter('Supply', Supply));
        if (Bulk) url = url.concat(this.createQueryStringParameter('Bulk', Bulk));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url, {
                responseType: 'text'})
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get document data"
                    });
                });
        });

        return promise;
    }

    private createQueryStringParameter(key: string, value: string) {
        var val = this.firstQueryString ? "?" : "&";
        this.firstQueryString = false;
        return val.concat(key).concat("=".concat(value));
    }


}
